import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  AddButton,
  Buttons,
  CancelButton,
  DeleteButton,
  UpdateButton,
} from '../../../components/Common/iComponents/iPopUp/IpopUp';

import { useSelector, useDispatch } from 'react-redux';

import { getClients } from '../../../store/client/actions';

import { IInput } from '../../../components/Common/iComponents/iInput/iInput';
import { ISwitch } from '../../../components/Common/iComponents/iSwitch/iSwitch';
import { ISelector } from '../../../components/Common/iComponents/iSelector/iSelector';

import { Label, FormGroup } from 'reactstrap';

const FormTasks = ({
  selectedRow,
  onCreateTask,
  onUpdateTask,
  onDeleteTask,
  onCancel,
}: any) => {
  const dispatch = useDispatch();

  const { clients } = useSelector((state: any) => state.clients);

  const arrayUpdAdd = [
    'empresa',
    'clienteId',
    'descripcion',
    'enabled',
    'code',
  ];
  const columsPop = 2;
  const [form, setForm] = useState({
    empresa: '',
    clienteId: '',
    descripcion: '',
    enabled: false,
    code: '',
  });
  const [flag, setflag] = useState<any>(true);

  const valuesSizeRolesPagination = [10, 20, 30, 40, 50, 100];
  const [paginationRoles, setPaginationRoles] = useState<any>({
    sizePerPage: valuesSizeRolesPagination[0],
    page: 1,
  });

  const initialArrayTableClients = [
    {
      text: 'Id',
      dataField: 'id',
      formatter: (cellContent: any, clients: any) => <>{clients.id}</>,
      hidden: false,
    },
    {
      text: 'Name',
      dataField: 'name',
      formatter: (cellContent: any, clients: any) => <>{clients.name}</>,
      hidden: false,
    },
  ];

  const handlePaginationRolesChange = (newState: any) => {
    setPaginationRoles(newState);
  };

  useEffect(() => {
    if (clients.length === 0) {
      dispatch(getClients({}));
    }
    if (selectedRow) {
      setForm(selectedRow);
    }
  }, [selectedRow]);

  const itemVals = (val: any, updateVal: any) => {
    for (const property in updateVal) {
      if (property === val) {
        return updateVal[property];
      }
    }
  };

  const renderButtons = () => (
    <Buttons>
      {selectedRow ? (
        <>
          <CancelButton
            className="button"
            onClick={() => onCancel()}
            data-bs-toggle="tooltip"
          >
            <i
              className="bx bx-power-off"
              style={{ fontSize: '2.5em' }}
              data-bs-toggle="tooltip"
            ></i>
          </CancelButton>
          <DeleteButton
            className="btn-delete"
            onClick={() => onDeleteTask(selectedRow.id)}
          >
            <i className="dripicons-trash" style={{ fontSize: '1.7em' }}></i>
          </DeleteButton>
          <UpdateButton
            className="button"
            disabled={flag}
            onClick={() => onUpdateTask(form)}
          >
            <i className="bx bx-sync" style={{ fontSize: '2.5em' }}></i>
          </UpdateButton>
        </>
      ) : (
        <AddButton
          type="submit"
          disabled={flag}
          className="btn"
          onClick={() => {
            onCreateTask(form);
          }}
        >
          <i className="bx bx-user-check" style={{ fontSize: '3.5em' }} />
        </AddButton>
      )}
    </Buttons>
  );

  useEffect(() => {
    const { empresa, clienteId, descripcion, code } = form;
    if (
      empresa !== '' &&
      clienteId !== '' &&
      descripcion !== '' &&
      code !== ''
    ) {
      setflag(false);
    } else {
      setflag(true);
    }
  }, [form]);

  const onChangeBooleanHandler = (e: any, n: any) => {
    setForm({
      ...form,
      [n]: !form[n as keyof typeof form],
    });
  };

  const onChangeHandler = (e: any, n: any) => {
    setForm({
      ...form,
      [n]: e.target.value,
    });
  };

  const onChangeSelectorHandler = (n: any, value: any) => {
    setForm({
      ...form,
      [n]: String(value.id),
    });
  };

  return (
    <>
      <div style={{ width: '650px', height: '450px' }}>
        <div className="row ms-5 pt-2">
          {arrayUpdAdd?.map((val: any) => {
            const className = 'col-6 pt-3';
            const nameObject = val as keyof typeof form;
            const temp = form[nameObject];
            const valid = temp ? true : false;
            let type = '';
            let nameSelector = '';
            const value = selectedRow ? itemVals(val, selectedRow) : null;

            switch (val) {
              case 'clienteId':
                nameSelector =
                  value || value === null
                    ? clients.filter(
                        (item: any) => Number(item.id) === Number(temp),
                      )[0]?.name
                    : '';
                return (
                  <div className={className}>
                    <ISelector
                      title={val}
                      value={String(temp)}
                      nameSelector={nameSelector ?? ''}
                      valuesSizePagination={valuesSizeRolesPagination}
                      dataSelector={clients}
                      CountItems={'10'}
                      initialArrayTable={initialArrayTableClients}
                      handlePaginationChange={handlePaginationRolesChange}
                      setSelectedRow={onChangeSelectorHandler}
                      onChangeHandler={onChangeHandler}
                    />
                  </div>
                );
              case 'code':
                type = 'textarea';
                break;
              case 'empresa':
                type = 'number';
                break;
              case 'enabled':
                return (
                  <div className={className}>
                    <FormGroup className="text-center">
                      <div className="text-capitalize">
                        <Label>{val.replace(/_/g, ' ').toLowerCase()}</Label>
                      </div>
                      <Label>
                        <ISwitch
                          title={val}
                          checked={Boolean(form[nameObject])}
                          onChangeBooleanHandler={onChangeBooleanHandler}
                        />
                      </Label>
                    </FormGroup>
                  </div>
                );
              default:
                type = 'text';
                break;
            }
            return (
              <div className={type === 'textarea' ? 'col-12 pt-2' : className}>
                <IInput
                  style={
                    type === 'textarea'
                      ? {
                          height: '250px',
                          maxHeight: '280px',
                          minHeight: '100px',
                        }
                      : {}
                  }
                  title={val}
                  valid={valid}
                  value={value}
                  type={type}
                  onChangeHandler={onChangeHandler}
                />
              </div>
            );
          })}
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          marginTop: '',
          marginRight: '1%',
        }}
      >
        {renderButtons()}
      </div>
    </>
  );
};

FormTasks.propTypes = {
  selectedRow: PropTypes.object,
  onCreateTask: PropTypes.func,
  onUpdateTask: PropTypes.func,
  onDeleteTask: PropTypes.func,
  onCancel: PropTypes.func,
};

export default FormTasks;
